import "./IconBookmark.scss";
import { ReactComponent as BookmarkIcon } from "./svg/bookmark.svg";

interface Props {
  className?: string;
}

export const IconBookmark = ({ className = "" }: Props) => {
  return (
    <span className={`IconBookmark ${className}`}>
      <BookmarkIcon />
    </span>
  );
};
